import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KfiRegistrationDto, ProductPickerDto, ProductPickerFilterDto, ProductPickerResponse } from '..';
import { Kfi } from '../../form-application/kfi';
import { FormApplication, MortgageClubsDto } from '../../form-application/shared';
import { ValidationErrors } from '../../lib';

@Injectable()
export class ProductPickerService {
  constructor(protected readonly httpClient: HttpClient) {}

  public getProducts(filter: ProductPickerDto): Observable<ProductPickerResponse> {
    return this.httpClient
      .post('/productPicker/products', filter)
      .pipe(map((productPickerResponse) => new ProductPickerResponse().deserialize(productPickerResponse)));
  }

  public getAllProducts(filter: ProductPickerFilterDto): Observable<ProductPickerResponse> {
    return this.httpClient
      .post('/productPicker/allproducts', filter)
      .pipe(map((productEntityDto) => new ProductPickerResponse().deserialize({ Entities: productEntityDto })));
  }

  public createKfi(filter: KfiRegistrationDto, caseNumberHash: string): Observable<Kfi> {
    const params = new HttpParams().set('caseNumber', caseNumberHash);

    return this.httpClient
      .post('/CaseManagement/CreateKfiForExistingApplicationCase', filter, { params })
      .pipe(map((kfi) => new Kfi().deserialize(kfi)));
  }

  public validateKfi(kfi: Kfi): Observable<ValidationErrors> {
    return this.httpClient
      .post('/CaseManagement/ValidateKfi', kfi)
      .pipe(map((validationErrors) => new ValidationErrors(validationErrors)));
  }

  public submitKfi(kfi: Kfi): Observable<any> {
    return this.httpClient.post('/CaseManagement/SubmitKfi', kfi);
  }

  public getMortgageClubs(application: FormApplication): Observable<MortgageClubsDto> {
    const params = new HttpParams().set('agentId', application.ApplicationCase.AgentID.toString());

    return this.httpClient.get('/InternalAgents/mortgageClubs', { params }).pipe(
      map((data: any) => {
        return data as MortgageClubsDto;
      })
    );
  }
}
